<template>
  <div>
    <br />
    <div
      id="alert"
      class="alert alert-dismissible fade show m-alert m-alert--outline mb-4 mt-4"
      :class="alert.color"
      role="alert"
      v-if="alert.message"
      ref="alert"
    >
      <button
        type="button"
        class="close"
        aria-label="Close"
        @click="alert.message = ''"
      ></button>
      <i :class="alert.icon"></i> &nbsp;<strong>{{ alert.message }}</strong
      ><br />
      {{ alert.reason }}
    </div>
    <div class v-if="data.data && data.data.length > 0">
      <a href data-toggle="modal" @click="download()">
        <button class="btn btn-outline-brand m-btn m-btn--outline">
          <i class="fas fa-download"></i> Baixar
        </button>
      </a>
    </div>

    <div class="row mt-3">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">Filtros extras</div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-2">
                <label for="filterCustomer">Grupo</label>
                <SelectCustomerGroups
                  id="filterCustomer"
                  :selected="filters.groupId"
                  @change="setFilter('groupId', $event)"
                  class="form-control-sm"
                  name="selectReport"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr />

    <div class="row">
      <div class="col-md-12">
        <div class="m-portlet m-portlet--tab">
          <div class="m-portlet__body">
            <div class="table-responsive">
              <div class="container-table">
                <table
                  class="table table-striped- table-bordered table-hover table-checkable"
                >
                  <caption></caption>
                  <thead>
                    <tr>
                      <th
                        id="customer_id"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle pointer"
                        :class="{ 'table-sorted': sortType == 'customer_id' }"
                        @click="sortCall('customer_id')"
                      >
                        ID Cliente
                        <span
                          class="fas fa-caret-down sorted"
                          v-if="sortType == 'customer_id' && !sortReverse"
                        ></span>
                        <span
                          class="fas fa-caret-up sorted"
                          v-if="sortType == 'customer_id' && sortReverse"
                        ></span>
                        <span
                          class="fal fa-sort sort"
                          v-if="sortType != 'customer_id'"
                        ></span>
                      </th>
                      <th
                        id="cnpj"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        CNPJ
                      </th>
                      <th
                        id="empresa"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Empresa
                      </th>
                      <th
                        id="status"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Status
                      </th>
                      <th
                        id="plano"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Plano
                      </th>
                      <th
                        id="segmento"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Segmento
                      </th>
                      <th
                        id="produto"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        &emsp; Produto &emsp;
                      </th>
                      <th
                        id="fatura_avulsa"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Fatura Avulsa
                      </th>
                      <th
                        id="cancelamento"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Cancelamento
                      </th>
                      <th
                        id="mes"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Mês
                      </th>
                      <th
                        id="data_faturamento_emissao"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Data de Faturamento/Emissão
                      </th>
                      <th
                        id="total_fatura"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Total Fatura
                      </th>
                      <th
                        id="adicionais"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Adicionais
                      </th>
                      <th
                        id="desconto"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Desconto
                      </th>
                      <th
                        id="acrescimo"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Acréscimo
                      </th>
                      <th
                        id="total_cobrado"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Total cobrado
                      </th>
                      <th
                        id="plano_mensal"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Plano Mensal
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Contratado
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Quantidade
                      </th>
                      <th
                        id="licencas"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Licenças
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Contratado
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Quantidade
                      </th>
                      <th
                        id="contatos_receptivos"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Contatos receptivos
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Contratado
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Quantidade
                      </th>
                      <th
                        id="numeros"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Números
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Contratado
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Quantidade
                      </th>
                      <th
                        id="ativos_unico"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Ativos - único
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Contratado
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Quantidade
                      </th>
                      <th
                        id="ativos_campanha"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Ativos - campanha
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Contratado
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Quantidade
                      </th>
                      <th
                        id="consultoria_mensal"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Consultoria Mensal
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Contratado
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Quantidade
                      </th>
                      <th
                        id="licencas_valor_minimo"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Licenças (valor mínimo)
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Contratado
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Quantidade
                      </th>
                      <th
                        id="ativos_unico_valor_minimo"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Ativos - único (valor mínimo)
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Contratado
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Quantidade
                      </th>
                      <th
                        id="ativos_campanha_valor_minimo"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Ativos - campanha (valor mínimo)
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Contratado
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Quantidade
                      </th>
                      <th
                        id="protocolos"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Protocolos
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Contratado
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Quantidade
                      </th>
                      <th
                        id="auto_negociador"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Auto Negociador
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Contratado
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Quantidade
                      </th>
                      <th
                        id="auto_negociador_valor_minimo"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Auto Negociador (valor mínimo)
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Contratado
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Quantidade
                      </th>
                      <th
                        id="cross_sell_engajamento"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Cross Sell Engajamento
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Contratado
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Quantidade
                      </th>
                      <th
                        id="setup_aquisicao"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Setup aquisição
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Contratado
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Quantidade
                      </th>
                      <th
                        id="numero_extra"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Número extra
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Contratado
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Quantidade
                      </th>
                      <th
                        id="consultoria"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Consultoria
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Contratado
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Quantidade
                      </th>
                      <th
                        id="customizacao"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Customização
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Contratado
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Quantidade
                      </th>
                      <th
                        id="suporte_24x7"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Suporte 24x7
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Contratado
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Quantidade
                      </th>
                      <th
                        id="outros"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Outros
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Contratado
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Quantidade
                      </th>
                      <th
                        id="atendimento"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Atendimento
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Contratado
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Quantidade
                      </th>
                      <th
                        id="contato_agenda"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Contato/Agenda
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Contratado
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Quantidade
                      </th>
                      <th
                        id="cpfs_unico"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        CPFs - Único
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Contratado
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Quantidade
                      </th>
                      <th
                        id="cancelamento_2"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Cancelamento
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Contratado
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Quantidade
                      </th>
                      <th
                        id="ativos_sms"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Ativos - SMS
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Contratado
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Quantidade
                      </th>
                      <th
                        id="contatos_envios_ativos"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Contatos + Envios de Ativos
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Contratado
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Quantidade
                      </th>
                      <th
                        id="ativos_unico_campanha"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Ativos único + Ativos de Campanha
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Contratado
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Quantidade
                      </th>
                      <th
                        id="ativos_unico_campanha"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Relatório
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Contratado
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Quantidade
                      </th>
                      <th
                        id="uam"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        UAM
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Contratado
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Quantidade
                      </th>
                      <th
                        id="hsm"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        HSM
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Contratado
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Quantidade
                      </th>
                      <th
                        id="hsm_ativos_unico"
                        class="text-center align-middle"
                        style="white-space: nowrap; min-width: 200px"
                      >
                        HSM - Ativos Único
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Contratado
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Quantidade
                      </th>
                      <th
                        id="hsm_ativos_campanha"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        HSM - Ativos Campanha
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Contratado
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Quantidade
                      </th>
                      <th
                        id="atendimento_protocolo"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Atendimento / Protocolo
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Contratado
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Quantidade
                      </th>
                      <th
                        id="ativos_campanha_sms"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Ativos Campanha - SMS
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Contratado
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Quantidade
                      </th>
                      <th
                        id="mensagens"
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Mensagens
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Contratado
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Quantidade
                      </th>
                      <th
                        id="sessao_autenticacao"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Sessão - Autenticação
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Contratado
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Quantidade
                      </th>
                      <th
                        id="sessao_utilitario"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Sessão - Utilitário
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Contratado
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Quantidade
                      </th>
                      <th
                        id="sessao_marketing"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Sessão - Marketing
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Contratado
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Quantidade
                      </th>
                      <th
                        id="sessao_servicos"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Sessão - Serviços
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Contratado
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Quantidade
                      </th>
                      <th
                        id="numeros_whatsapp_enterprise"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Números Whatsapp Enterprise
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Contratado
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Quantidade
                      </th>
                      <th
                        id="numeros_whatsapp_enterprise"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Adicionais
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Contratado
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Quantidade
                      </th>
                      <th
                        id="numeros_whatsapp_enterprise"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Projetos de Aquisição
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Contratado
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Quantidade
                      </th>
                      <th
                        id="numeros_whatsapp_enterprise"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Setup Base
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Contratado
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Quantidade
                      </th>
                      <th
                        id="numeros_whatsapp_enterprise"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Projetos Base
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Contratado
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Quantidade
                      </th>
                      <th
                        id="numeros_whatsapp_enterprise"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Cancelamento
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Contratado
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Quantidade
                      </th>
                      <th
                        id="numeros_whatsapp_enterprise"
                        class="text-center align-middle"
                        style="white-space: nowrap; width: 200px"
                      >
                        Multas Contratuais
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Contratado
                      </th>
                      <th
                        style="white-space: nowrap; min-width: 200px"
                        class="text-center align-middle"
                      >
                        Quantidade
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          v-bind:class="{
                            inputTextFilter: !data || data.length == 0,
                          }"
                          v-model="filters.customer_id"
                          :disabled="disabledFilters"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          v-bind:class="{
                            inputTextFilter: !data || data.length == 0,
                          }"
                          v-model="filters.cnpj"
                          :disabled="disabledFilters"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          v-bind:class="{
                            inputTextFilter: !data || data.length == 0,
                          }"
                          v-model="filters.name"
                          :disabled="disabledFilters"
                        />
                      </td>
                      <td>
                        <SelectStatuses
                          :selected="filters.status"
                          @change="setFilter('status', $event)"
                          class="form-control-sm"
                        />
                      </td>
                      <td>
                        <SelectPlanTypes
                          :selected="filters.plan_type_id"
                          @change="setFilter('plan_type_id', $event)"
                          class="form-control-sm"
                        />
                      </td>
                      <td></td>
                      <td>
                        <SelectProducts
                          :selected="filters.product"
                          @change="setFilter('product', $event)"
                          class="form-control-sm"
                          :productsNotAppear="[2, 3, 4, 5, 6]"
                        />
                      </td>
                      <td>
                        <SelectYesNo
                          :selected="filters.detached"
                          @change="setFilter('detached', $event)"
                          class="form-control-sm"
                        />
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr v-for="(invoice, id) in data.data" :key="id">
                      <td class="text-center align-middle">
                        {{ invoice.customer_id }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          invoice.customer
                            ? invoice.customer.documents.value
                            : null | cnpj | cpf
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.co_name }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ getStatus(invoice.status) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          invoice.plan_type
                            ? invoice.plan_type
                            : invoice.plan_description
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.segment }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.product.name }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.detached }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.cancellation ? 'Sim' : 'Não' }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.billing_month | date }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.billing_date_external | date }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.price_total | money }}
                      </td>
                      <td>
                        {{
                          calcAditionals(
                            invoice.price_total,
                            invoice.discount,
                            sumTotal(invoice.details, detailsIds.PACKAGE_IDS)
                          ) | money
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.discount | money }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.price_extra | money }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ (invoice.price_total - invoice.discount) | money }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumTotal(invoice.details, detailsIds.PACKAGE_IDS)
                            | money
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.contract_package }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumAmount(invoice.details, detailsIds.PACKAGE_IDS) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumTotal(invoice.details, detailsIds.LICENCE) | money
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.contract_licence }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumAmount(invoice.details, detailsIds.LICENCE) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumTotal(invoice.details, detailsIds.CONTACT) | money
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.contract_contact }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumAmount(invoice.details, detailsIds.CONTACT) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumTotal(invoice.details, detailsIds.NUMBER) | money
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.contract_number }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumAmount(invoice.details, detailsIds.NUMBER) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumTotal(invoice.details, detailsIds.ACTIVE_UNIQUE)
                            | money
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.contract_active_unique }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumAmount(invoice.details, detailsIds.ACTIVE_UNIQUE)
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumTotal(invoice.details, detailsIds.ACTIVE_CAMPAIGN)
                            | money
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.contract_active_campaign }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumAmount(invoice.details, detailsIds.ACTIVE_CAMPAIGN)
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumTotal(invoice.details, detailsIds.CONSULTING)
                            | money
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.contract_consulting }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumAmount(invoice.details, detailsIds.CONSULTING) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumTotal(invoice.details, detailsIds.LICENCE_MIN)
                            | money
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.contract_licence_min }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumAmount(invoice.details, detailsIds.LICENCE_MIN) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumTotal(
                            invoice.details,
                            detailsIds.ACTIVE_UNIQUE_MIN
                          ) | money
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.contract_active_unique_min }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumAmount(
                            invoice.details,
                            detailsIds.ACTIVE_UNIQUE_MIN
                          )
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumTotal(
                            invoice.details,
                            detailsIds.ACTIVE_CAMPAIGN_MIN
                          ) | money
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.contract_active_campaign_min }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumAmount(
                            invoice.details,
                            detailsIds.ACTIVE_CAMPAIGN_MIN
                          )
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumTotal(invoice.details, detailsIds.PROTOCOLS)
                            | money
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.contract_protocols }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumAmount(invoice.details, detailsIds.PROTOCOLS) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumTotal(invoice.details, detailsIds.AUTONEGOTIATOR)
                            | money
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.contract_autonegotiator }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumAmount(invoice.details, detailsIds.AUTONEGOTIATOR)
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumTotal(
                            invoice.details,
                            detailsIds.AUTONEGOTIATOR_MIN
                          ) | money
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.contract_autonegotiator_min }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumAmount(
                            invoice.details,
                            detailsIds.AUTONEGOTIATOR_MIN
                          )
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumTotal(invoice.details, detailsIds.CROSS_SELL)
                            | money
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.contract_cross_sell }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumAmount(invoice.details, detailsIds.CROSS_SELL) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumTotal(
                            invoice.details,
                            detailsIds.SETUP_ACQUISITION
                          ) | money
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.contract_setup_aquisition }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumAmount(
                            invoice.details,
                            detailsIds.SETUP_ACQUISITION
                          )
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumTotal(invoice.details, detailsIds.NUMBER_EXTRA)
                            | money
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.contract_enterprise_number }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumAmount(invoice.details, detailsIds.NUMBER_EXTRA)
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumTotal(invoice.details, detailsIds.CONSULTING)
                            | money
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.contract_consulting }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumAmount(invoice.details, detailsIds.CONSULTING) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumTotal(invoice.details, detailsIds.CUSTOMIZATION)
                            | money
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.contract_customization }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumAmount(invoice.details, detailsIds.CUSTOMIZATION)
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumTotal(invoice.details, detailsIds.SUPORT24X7)
                            | money
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.contract_support24x7 }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumAmount(invoice.details, detailsIds.SUPORT24X7) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumTotal(invoice.details, detailsIds.OTHER) | money
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.contract_other }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumAmount(invoice.details, detailsIds.OTHER) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumTotal(invoice.details, detailsIds.CHATBOT_PROTOCOL)
                            | money
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.contract_chatbot_protocolo }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumAmount(
                            invoice.details,
                            detailsIds.CHATBOT_PROTOCOL
                          )
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumTotal(invoice.details, detailsIds.CHATBOT_SCHEDULE)
                            | money
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.contract_chatbot_agenda }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumAmount(
                            invoice.details,
                            detailsIds.CHATBOT_SCHEDULE
                          )
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumTotal(
                            invoice.details,
                            detailsIds.CHATBOT_CPF_UNIQUE
                          ) | money
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.contract_chatbot_cpf_uniq }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumAmount(
                            invoice.details,
                            detailsIds.CHATBOT_CPF_UNIQUE
                          )
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumTotal(invoice.details, detailsIds.CANCELLATION)
                            | money
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.contract_cancellation }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumAmount(invoice.details, detailsIds.CANCELLATION)
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumTotal(invoice.details, detailsIds.ACTIVE_SMS)
                            | money
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.contract_active_sms }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumAmount(invoice.details, detailsIds.ACTIVE_SMS) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumTotal(invoice.details, detailsIds.CONTACT_UNIFIED)
                            | money
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.contract_contact_unified }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumAmount(invoice.details, detailsIds.CONTACT_UNIFIED)
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumTotal(
                            invoice.details,
                            detailsIds.ACTIVE_UNIFIED_UNIQUE_CAMPAIGN
                          ) | money
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.contract_contact_unified_active_campaign }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumAmount(
                            invoice.details,
                            detailsIds.ACTIVE_UNIFIED_UNIQUE_CAMPAIGN
                          )
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumTotal(invoice.details, detailsIds.REPORT) | money
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.contract_report }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumAmount(invoice.details, detailsIds.REPORT) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumTotal(invoice.details, detailsIds.UAM) | money }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.contract_enterprise_contact }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumAmount(invoice.details, detailsIds.UAM) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumTotal(invoice.details, detailsIds.HSM) | money }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.contract_enterprise_active }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumAmount(invoice.details, detailsIds.HSM) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumTotal(
                            invoice.details,
                            detailsIds.HSM_ACTIVE_UNIQUE
                          ) | money
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.contract_enterprise_active_unique }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumAmount(
                            invoice.details,
                            detailsIds.HSM_ACTIVE_UNIQUE
                          )
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumTotal(
                            invoice.details,
                            detailsIds.HSM_ACTIVE_CAMPAIGN
                          ) | money
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.contract_attendance_protocol }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumAmount(
                            invoice.details,
                            detailsIds.HSM_ACTIVE_CAMPAIGN
                          )
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumTotal(
                            invoice.details,
                            detailsIds.ATTENDANCE_PROTOCOL
                          ) | money
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.contract_attendance_protocol }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumAmount(
                            invoice.details,
                            detailsIds.ATTENDANCE_PROTOCOL
                          )
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumTotal(
                            invoice.details,
                            detailsIds.ACTIVE_CAMPAIGN_SMS
                          ) | money
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.contract_active_campaign_sms }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumAmount(
                            invoice.details,
                            detailsIds.ACTIVE_CAMPAIGN_SMS
                          )
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumTotal(invoice.details, detailsIds.MESSAGE) | money
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.contract_message }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumAmount(invoice.details, detailsIds.MESSAGE) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumTotal(
                            invoice.details,
                            detailsIds.SESSION_AUTHENTICATION
                          ) | money
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.contract_enterprise_session_authentication }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumAmount(
                            invoice.details,
                            detailsIds.SESSION_AUTHENTICATION
                          )
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumTotal(invoice.details, detailsIds.SESSION_UTILITY)
                            | money
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.contract_enterprise_session_utility }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumAmount(invoice.details, detailsIds.SESSION_UTILITY)
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumTotal(
                            invoice.details,
                            detailsIds.SESSION_MARKETING
                          ) | money
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.contract_enterprise_session_marketing }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumAmount(
                            invoice.details,
                            detailsIds.SESSION_MARKETING
                          )
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumTotal(invoice.details, detailsIds.SESSION_SERVICE)
                            | money
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.contract_enterprise_session_service }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumAmount(invoice.details, detailsIds.SESSION_SERVICE)
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.contract_enterprise_session_service }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumTotal(
                            invoice.details,
                            detailsIds.ENTERPRISE_NUMBER
                          ) | money
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.contract_enterprise_number }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumAmount(
                            invoice.details,
                            detailsIds.ENTERPRISE_NUMBER
                          )
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumTotal(invoice.details, detailsIds.ADDITIONAL)
                            | money
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.contract_additional }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumAmount(invoice.details, detailsIds.ADDITIONAL) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumTotal(
                            invoice.details,
                            detailsIds.PROJECT_ACQUISITION
                          ) | money
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.contract_project_aquisition }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumAmount(
                            invoice.details,
                            detailsIds.PROJECT_ACQUISITION
                          )
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumTotal(invoice.details, detailsIds.SETUP_BASE)
                            | money
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.contract_setup_base }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ sumAmount(invoice.details, detailsIds.SETUP_BASE) }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumTotal(invoice.details, detailsIds.PROJECT_BASE)
                            | money
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.contract_project_aquisition }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumAmount(invoice.details, detailsIds.PROJECT_BASE)
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumTotal(invoice.details, detailsIds.CANCELLATION)
                            | money
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.contract_cancellation }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumAmount(invoice.details, detailsIds.CANCELLATION)
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumTotal(
                            invoice.details,
                            detailsIds.CONTRACTUAL_FINES
                          ) | money
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{ invoice.contract_fines }}
                      </td>
                      <td
                        class="text-center align-middle"
                        style="white-space: nowrap"
                      >
                        {{
                          sumAmount(
                            invoice.details,
                            detailsIds.CONTRACTUAL_FINES
                          )
                        }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div>
              <div class="paginator-info-bottom mt-2">
                <span class="m--font-gray" v-if="data.from"
                  >Exibindo itens de {{ data.from }} a {{ data.to }}, de um
                  total de {{ data.total }}.</span
                >
                <span class="m--font-gray" v-else
                  >Nenhum item a ser exibido.</span
                >
              </div>
              <div class="paginator-list">
                <nav aria-label="...">
                  <ul class="pagination pagination-md">
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == 1 }"
                    >
                      <a class="page-link paginate" @click="page = 1">
                        <i class="fal fa-angle-double-left"></i>
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == 1 }"
                    >
                      <a
                        class="page-link paginate"
                        @click="page = data.current_page - 1"
                      >
                        <i class="fal fa-angle-left"></i>
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == 1 }"
                      v-if="data.current_page > 2"
                    >
                      <a
                        class="page-link paginate"
                        @click="page = data.current_page - 2"
                        >{{ data.current_page - 2 }}</a
                      >
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == 1 }"
                      v-if="data.current_page > 1"
                    >
                      <a
                        class="page-link paginate"
                        @click="page = data.current_page - 1"
                        >{{ data.current_page - 1 }}</a
                      >
                    </li>
                    <li class="page-item selected">
                      <a class="page-link paginate">{{ data.current_page }}</a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == data.last_page }"
                      v-if="data.current_page < data.last_page"
                    >
                      <a
                        class="page-link paginate"
                        @click="page = data.current_page + 1"
                        >{{ data.current_page + 1 }}</a
                      >
                    </li>
                    <li
                      class="page-item"
                      :class="{
                        disabled: data.current_page + 1 == data.last_page,
                      }"
                      v-if="data.current_page + 1 < data.last_page"
                    >
                      <a
                        class="page-link paginate"
                        @click="page = data.current_page + 2"
                        >{{ data.current_page + 2 }}</a
                      >
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == data.last_page }"
                    >
                      <a
                        class="page-link paginate"
                        @click="page = data.current_page + 1"
                      >
                        <i class="fal fa-angle-right"></i>
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == data.last_page }"
                    >
                      <a
                        class="page-link paginate"
                        @click="page = data.last_page"
                      >
                        <i class="fal fa-angle-double-right"></i>
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
            <div class="pt-4"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SelectProducts from '@/components/forms/SelectProducts';
import SelectStatuses from '@/components/forms/SelectInvoiceStatuses';
import SelectPlanTypes from '@/components/forms/SelectPlanTypes';
import SelectYesNo from '@/components/forms/SelectYesNo';
import { returnMessageMixin } from '@/mixins/returnMessageMixin.js';
import SelectContractStatus from '@/components/forms/SelectContractStatus';
import SelectCustomerGroups from '@/components/forms/SelectCustomerGroups';
import { detailsIds } from '../../../constants';

import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  mixins: [returnMessageMixin],
  name: 'ReportInvoiceAnalyticsGeneral',
  props: ['start', 'finish', 'createdAt'],
  components: {
    SelectProducts,
    SelectContractStatus,
    SelectStatuses,
    SelectPlanTypes,
    SelectYesNo,
    SelectCustomerGroups,
  },
  setup() {
    return {
      detailsIds,
    };
  },
  data() {
    return {
      detailsIds,
      disabledFilters: false,
      alert: {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      },
      sortType: localStorage.reportInvoicesAnalyticsSortType
        ? localStorage.reportInvoicesAnalyticsSortType
        : 'id',
      sortReverse: localStorage.reportInvoicesAnalyticsSortReverse
        ? JSON.parse(localStorage.reportInvoicesAnalyticsSortReverse)
        : false,
      amount: localStorage.reportInvoicesAnalyticsDataAmount
        ? localStorage.reportInvoicesAnalyticsDataAmount
        : 100,
      page: localStorage.reportInvoicesAnalyticsDataPage
        ? localStorage.reportInvoicesAnalyticsDataPage
        : 1,
      filters: {
        id: localStorage.reportInvoicesAnalyticsFilterId
          ? localStorage.reportInvoicesAnalyticsFilterId
          : '',
        customer_id: localStorage.reportInvoicesAnalyticsFilterCustomer
          ? localStorage.reportInvoicesAnalyticsFilterCustomer
          : '',
        name: localStorage.reportInvoicesAnalyticsFilterName
          ? localStorage.reportInvoicesAnalyticsFilterName
          : '',
        cnpj: localStorage.reportInvoicesAnalyticsFilterCnpj
          ? localStorage.reportInvoicesAnalyticsFilterCnpj
          : '',
        product: localStorage.reportInvoicesAnalyticsFilterProduct
          ? localStorage.reportInvoicesAnalyticsFilterProduct
          : '',
      },
      data: [],
    };
  },
  computed: {
    loading() {
      return !this.data.current_page;
    },
  },
  methods: {
    clearAlert() {
      this.alert = {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      };
    },
    async download() {
      this.alert = {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: 'Gerando relatório',
        reason: '',
      };

      const urlCount =
        `${baseApiUrl}/v1/report/invoice/analytics/` +
        `count${this.convertFilters()}`;
      const total = await axios.get(urlCount);

      let arrData = [];
      let pages = Math.ceil(total.data / 100);
      for (let index = 1; index <= pages; index++) {
        let data = await this.getDataByPages(index);
        arrData = arrData.concat(data);
      }
      let csvContent = 'data:text/csv;charset=utf-8,';
      let array = this.mountArray(arrData);
      csvContent += array.join('\n').replace(/(^\[)|(\]$)/gm, '');

      const data = encodeURI(csvContent);

      const link = document.createElement('a');
      link.setAttribute('href', data);

      let fileName = `relatorio_analitico_faturamento_geral`;

      this.clearAlert();
      if (this.start) {
        fileName += `_${this.start}`;
      }
      fileName = `${fileName}.csv`;
      link.setAttribute('download', fileName);

      link.click();
    },

    getDataByPages(index) {
      const url =
        `${baseApiUrl}/v1/report/invoice/analytics/general/page/` +
        `${index}/download${this.convertFilters()}`;

      return axios
        .get(url)
        .then((res) => {
          return res.data;
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
    generate() {
      this.callData();
    },
    setFilter(filterToChange, id) {
      this.disabledFilters = false;
      if (filterToChange == 'groupId' && id) {
        this.disabledFilters = true;
      }
      this.filters[filterToChange] = id;
    },
    clearFilters() {
      this.filters.customer_id = '';
      this.filters.name = '';
      this.filters.cnpj = '';
      this.status = '';
      this.filters.product = '';
      this.filters.sortType = 'customer_id';
      this.filters.sortReverse = false;
      this.filters.plan_type_id = '';
      this.filters.detached = '';
      this.filters.groupId = '';
      this.callData();
    },
    setStorageFilters() {
      localStorage.setItem('reportInvoicesAnalyticsFilterId', this.filters.id);
      localStorage.setItem(
        'reportInvoicesAnalyticsFilterCustomer',
        this.filters.customer_id
      );
      localStorage.setItem(
        'reportInvoicesAnalyticsFilterName',
        this.filters.name
      );
      localStorage.setItem(
        'reportInvoicesAnalyticsFilterCnpj',
        this.filters.cnpj
      );
      localStorage.setItem(
        'reportInvoicesAnalyticsFilterStatus',
        this.filters.status
      );
      localStorage.setItem(
        'reportInvoicesAnalyticsFilterProduct',
        this.filters.product
      );
      localStorage.setItem('reportInvoicesAnalyticsDataAmount', this.amount);
      localStorage.setItem('reportInvoicesAnalyticsDataPage', this.page);
      localStorage.setItem('reportInvoicesAnalyticsSortType', this.sortType);
      localStorage.setItem(
        'reportInvoicesAnalyticsSortReverse',
        this.sortReverse
      );
      localStorage.setItem(
        'reportInvoicesAnalyticsFilterId',
        this.filters.plan_type_id
      );
      localStorage.setItem(
        'reportInvoicesAnalyticsFilterDetached',
        this.filters.detached
      );
      localStorage.setItem(
        'reportInvoicesAnalyticsFilterGroupId',
        this.filters.groupId
      );
    },
    convertFilters() {
      const filters = `?page=${this.page ? this.page : 1}&id=${
        this.filters.id ? this.filters.id : ''
      }&customer=${this.filters.customer_id ? this.filters.customer_id : ''}
        &name=${this.filters.name ? this.filters.name : ''}&cnpj=${
        this.filters.cnpj ? this.filters.cnpj : ''
      }&status=${this.filters.status ? this.filters.status : ''}&product=${
        this.filters.product ? this.filters.product : ''
      }&planType=${
        this.filters.plan_type_id ? this.filters.plan_type_id : ''
      }&amount=${this.amount}&detached=${
        this.filters.detached ? this.filters.detached : ''
      }&sortType=${this.sortType}&sortOrder=${this.sortReverse ? 'DESC' : 'ASC'}
      &start=${this.start}
      &end=${this.finish ? this.finish : this.start}
      &createdAt=${this.createdAt}
      &groupId=${this.filters.groupId}`;

      return filters;
    },
    sortCall(sortType) {
      this.sortReverse = this.sortType == sortType ? !this.sortReverse : false;
      this.sortType = sortType;
    },
    callData() {
      this.data.current_page = 0;
      this.setStorageFilters();
      this.getDatas();
    },
    getDatas() {
      const url =
        `${baseApiUrl}/v1/report/invoice/` +
        `analytics/general${this.convertFilters()}`;
      axios(url)
        .then((res) => {
          this.data = res.data;
          this.$emit('updateLoading');
          if (res.data.current_page > res.data.last_page) {
            this.page = 1;
          }
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
    sumTotal(details, ids) {
      return details
        .filter((item) => ids.includes(item.detail_id))
        .map((item) => parseFloat(item.total))
        .reduce((prev, curr) => prev + curr, 0);
    },
    sumAmount(details, ids) {
      return details
        .filter((item) => ids.includes(item.detail_id))
        .map((item) => parseFloat(item.amount))
        .reduce((prev, curr) => prev + curr, 0);
    },
    mountArray(arrayInvoices) {
      let linesArray = [];
      linesArray[0] =
        'ID Cliente;CNPJ;Empresa;Status;Plano;Segmento;Produto;' +
        'Fatura Avulsa;Cancelamento;Mês;Data de Faturamento/Emissão;' +
        'Total Fatura;Adicionais;Desconto;Acréscimo;Total Cobrado;' +
        'Plano Mensal;Contratado;Quantidade;Licenças;Contratado;Quantidade;' +
        'Contatos receptivos;Contratado;Quantidade;Números;Contratado;' +
        'Quantidade;Ativos - único;Contratado;Quantidade;Ativos - campanha;' +
        'Contratado;Quantidade;Consultoria mensal;Contratado;Quantidade;' +
        'Licenças (valor mínimo);Contratado;Quantidade;Ativos - único ' +
        '(valor mínimo);Contratado;Quantidade;Ativos - campanha (valor mínimo);' +
        'Contratado;Quantidade;Protocolos;Contratado;Quantidade;Auto Negociador;' +
        'Contratado;Quantidade;Auto Negociador (valor mínimo);Contratado;' +
        'Quantidade;Cross Sell Engajamento;Contratado;Quantidade;Setup aquisição;' +
        'Contratado;Quantidade;Número extra;Contratado;Quantidade;Consultoria;' +
        'Contratado;Quantidade;Customização;Contratado;Quantidade;' +
        'Suporte 24x7;Contratado;Quantidade;Outros;Contratado;Quantidade;' +
        'Atendimento;Contratado;Quantidade;Contato/Agenda;Contratado;' +
        'Quantidade;CPFs - Único;Contratado;Quantidade;Cancelamento;' +
        'Contratado;Quantidade;Ativos - SMS;Contratado;Quantidade;' +
        'Contatos + Envios de Ativos;Contratado;Quantidade;Ativos Único + ' +
        'Ativos Campanha;Contratado;Quantidade;Relatório;Contratado;' +
        'Quantidade;UAM;Contratado;Quantidade;HSM;Contratado;Quantidade;' +
        'HSM - Ativos Único;Contratado;Quantidade;HSM - Ativos Campanha;' +
        'Contratado;Quantidade;Atendimento / Protocolo;Contratado;' +
        'Quantidade;Ativos Campanha - SMS;Contratado;Quantidade;' +
        'Mensagens;Contratado;Quantidade;Sessão - Autenticação;Contratado;' +
        'Quantidade;Sessão - Utilitário;Contratado;Quantidade;Sessão - Marketing;' +
        'Contratado;Quantidade;Sessão - Serviços;Contratado;Quantidade;' +
        'Números Whatsapp Enterprise;Contratado;Quantidade;Adicionais;' +
        'Contratado;Quantidade;Projetos de Aquisição;Contratado;Quantidade;' +
        'Setup Base;Contratado;Quantidade;Projetos Base;Contratado;' +
        'Quantidade;Cancelamento;Contratado;Quantidade;Multas Contratuais;' +
        'Contratado;Quantidade';
      arrayInvoices.forEach((item) => {
        const line =
          item.customer_id +
          ';' +
          item.customer.documents.value +
          ';' +
          (item.co_name || '') +
          ';' +
          this.getStatus(item.status) +
          ';' +
          (item.plan_type
            ? item.plan_type
            : item.plan_description
            ? item.plan_description
            : '') +
          ';' +
          item.segment +
          ';' +
          item.product.name +
          ';' +
          item.detached +
          ';' +
          (item.cancellation ? 'Sim' : 'Não') +
          ';' +
          item.billing_month +
          ';' +
          (item.billing_date_external ? item.billing_date_external : '') +
          ';' +
          this.formatCurrency(item.price_total) +
          ';' +
          this.formatCurrency(
            this.calcAditionals(
              item.price_total,
              item.discount,
              this.sumTotal(item.details, detailsIds.PACKAGE_IDS)
            )
          ) +
          ';' +
          this.formatCurrency(item.discount) +
          ';' +
          this.formatCurrency(item.price_extra) +
          ';' +
          this.formatCurrency(item.price_total - item.discount) +
          ';' +
          this.formatCurrency(
            this.sumTotal(item.details, detailsIds.PACKAGE_IDS)
          ) +
          ';' +
          (item.contract_package ? item.contract_package : '') +
          ';' +
          this.sumAmount(item.details, detailsIds.PACKAGE_IDS) +
          ';' +
          this.formatCurrency(this.sumTotal(item.details, detailsIds.LICENCE)) +
          ';' +
          (item.contract_licence ? item.contract_licence : '') +
          ';' +
          this.sumAmount(item.details, detailsIds.LICENCE) +
          ';' +
          this.formatCurrency(this.sumTotal(item.details, detailsIds.CONTACT)) +
          ';' +
          (item.contract_contact ? item.contract_contact : '') +
          ';' +
          this.sumAmount(item.details, detailsIds.CONTACT) +
          ';' +
          this.formatCurrency(this.sumTotal(item.details, detailsIds.NUMBER)) +
          ';' +
          (item.contract_number ? item.contract_number : '') +
          ';' +
          this.sumAmount(item.details, detailsIds.NUMBER) +
          ';' +
          this.formatCurrency(
            this.sumTotal(item.details, detailsIds.ACTIVE_UNIQUE)
          ) +
          ';' +
          (item.contract_active_unique ? item.contract_active_unique : '') +
          ';' +
          this.sumAmount(item.details, detailsIds.ACTIVE_UNIQUE) +
          ';' +
          this.formatCurrency(
            this.sumTotal(item.details, detailsIds.ACTIVE_CAMPAIGN)
          ) +
          ';' +
          (item.contract_active_campaign ? item.contract_active_campaign : '') +
          ';' +
          this.sumAmount(item.details, detailsIds.ACTIVE_CAMPAIGN) +
          ';' +
          this.formatCurrency(
            this.sumTotal(item.details, detailsIds.CONSULTING_MONTH)
          ) +
          ';' +
          (item.contract_consulting ? item.contract_consulting : '') +
          ';' +
          this.sumAmount(item.details, detailsIds.CONSULTING_MONTH) +
          ';' +
          this.formatCurrency(
            this.sumTotal(item.details, detailsIds.LICENCE_MIN)
          ) +
          ';' +
          (item.contract_licence_min ? item.contract_licence_min : '') +
          ';' +
          this.sumAmount(item.details, detailsIds.LICENCE_MIN) +
          ';' +
          this.formatCurrency(
            this.sumTotal(item.details, detailsIds.ACTIVE_UNIQUE_MIN)
          ) +
          ';' +
          (item.contract_active_unique_min
            ? item.contract_active_unique_min
            : '') +
          ';' +
          this.sumAmount(item.details, detailsIds.ACTIVE_UNIQUE_MIN) +
          ';' +
          this.formatCurrency(
            this.sumTotal(item.details, detailsIds.ACTIVE_CAMPAIGN_MIN)
          ) +
          ';' +
          (item.contract_active_campaign_min
            ? item.contract_active_campaign_min
            : '') +
          ';' +
          this.sumAmount(item.details, detailsIds.ACTIVE_CAMPAIGN_MIN) +
          ';' +
          this.formatCurrency(
            this.sumTotal(item.details, detailsIds.PROTOCOLS)
          ) +
          ';' +
          (item.contract_protocols ? item.contract_protocols : '') +
          ';' +
          this.sumAmount(item.details, detailsIds.PROTOCOLS) +
          ';' +
          this.formatCurrency(
            this.sumTotal(item.details, detailsIds.AUTONEGOTIATOR)
          ) +
          ';' +
          (item.contract_autonegotiator ? item.contract_autonegotiator : '') +
          ';' +
          this.sumAmount(item.details, detailsIds.AUTONEGOTIATOR) +
          ';' +
          this.formatCurrency(
            this.sumTotal(item.details, detailsIds.AUTONEGOTIATOR_MIN)
          ) +
          ';' +
          (item.contract_autonegotiator_min
            ? item.contract_autonegotiator_min
            : '') +
          ';' +
          this.sumAmount(item.details, detailsIds.AUTONEGOTIATOR_MIN) +
          ';' +
          this.formatCurrency(
            this.sumTotal(item.details, detailsIds.CROSS_SELL)
          ) +
          ';' +
          (item.contract_cross_sell ? item.contract_cross_sell : '') +
          ';' +
          this.sumAmount(item.details, detailsIds.CROSS_SELL) +
          ';' +
          this.formatCurrency(
            this.sumTotal(item.details, detailsIds.SETUP_ACQUISITION)
          ) +
          ';' +
          (item.contract_setup_aquisition
            ? item.contract_setup_aquisition
            : '') +
          ';' +
          this.sumAmount(item.details, detailsIds.SETUP_ACQUISITION) +
          ';' +
          this.formatCurrency(
            this.sumTotal(item.details, detailsIds.NUMBER_EXTRA)
          ) +
          ';' +
          (item.contract_number_extra ? item.contract_number_extra : '') +
          ';' +
          this.sumAmount(item.details, detailsIds.NUMBER_EXTRA) +
          ';' +
          this.formatCurrency(
            this.sumTotal(item.details, detailsIds.CONSULTING)
          ) +
          ';' +
          (item.contract_consulting ? item.contract_consulting : '') +
          ';' +
          this.sumAmount(item.details, detailsIds.CONSULTING) +
          ';' +
          this.formatCurrency(
            this.sumTotal(item.details, detailsIds.CUSTOMIZATION)
          ) +
          ';' +
          (item.contract_customization ? item.contract_customization : '') +
          ';' +
          this.sumAmount(item.details, detailsIds.CUSTOMIZATION) +
          ';' +
          this.formatCurrency(
            this.sumTotal(item.details, detailsIds.SUPORT24X7)
          ) +
          ';' +
          (item.contract_support24x7 ? item.contract_support24x7 : '') +
          ';' +
          this.sumAmount(item.details, detailsIds.SUPORT24X7) +
          ';' +
          this.formatCurrency(this.sumTotal(item.details, detailsIds.OTHER)) +
          ';' +
          (item.contract_other ? item.contract_other : '') +
          ';' +
          this.sumAmount(item.details, detailsIds.OTHER) +
          ';' +
          this.formatCurrency(
            this.sumTotal(item.details, detailsIds.CHATBOT_PROTOCOL)
          ) +
          ';' +
          (item.contract_chatbot_protocolo
            ? item.contract_chatbot_protocolo
            : '') +
          ';' +
          this.sumAmount(item.details, detailsIds.CHATBOT_PROTOCOL) +
          ';' +
          this.formatCurrency(
            this.sumTotal(item.details, detailsIds.CHATBOT_SCHEDULE)
          ) +
          ';' +
          (item.contract_chatbot_agenda ? item.contract_chatbot_agenda : '') +
          ';' +
          this.sumAmount(item.details, detailsIds.CHATBOT_SCHEDULE) +
          ';' +
          this.formatCurrency(
            this.sumTotal(item.details, detailsIds.CHATBOT_CPF_UNIQUE)
          ) +
          ';' +
          (item.contract_chatbot_cpf_uniq
            ? item.contract_chatbot_cpf_uniq
            : '') +
          ';' +
          this.sumAmount(item.details, detailsIds.CHATBOT_CPF_UNIQUE) +
          ';' +
          this.formatCurrency(
            this.sumTotal(item.details, detailsIds.CANCELLATION)
          ) +
          ';' +
          (item.contract_cancellation ? item.contract_cancellation : '') +
          ';' +
          this.sumAmount(item.details, detailsIds.CANCELLATION) +
          ';' +
          this.formatCurrency(
            this.sumTotal(item.details, detailsIds.ACTIVE_SMS)
          ) +
          ';' +
          (item.contract_active_sms ? item.contract_active_sms : '') +
          ';' +
          this.sumAmount(item.details, detailsIds.ACTIVE_SMS) +
          ';' +
          this.formatCurrency(
            this.sumTotal(item.details, detailsIds.CONTACT_UNIFIED)
          ) +
          ';' +
          (item.contract_contact_unified ? item.contract_contact_unified : '') +
          ';' +
          this.sumAmount(item.details, detailsIds.CONTACT_UNIFIED) +
          ';' +
          this.formatCurrency(
            this.sumTotal(
              item.details,
              detailsIds.ACTIVE_UNIFIED_UNIQUE_CAMPAIGN
            )
          ) +
          ';' +
          (item.contract_contact_unified_active_campaign
            ? item.contract_contact_unified_active_campaign
            : '') +
          ';' +
          this.sumAmount(
            item.details,
            detailsIds.ACTIVE_UNIFIED_UNIQUE_CAMPAIGN
          ) +
          ';' +
          this.formatCurrency(this.sumTotal(item.details, detailsIds.REPORT)) +
          ';' +
          (item.contract_report ? item.contract_report : '') +
          ';' +
          this.sumAmount(item.details, detailsIds.REPORT) +
          ';' +
          this.formatCurrency(this.sumTotal(item.details, detailsIds.UAM)) +
          ';' +
          (item.contract_enterprise_contact
            ? item.contract_enterprise_contact
            : '') +
          ';' +
          this.sumAmount(item.details, detailsIds.UAM) +
          ';' +
          this.formatCurrency(this.sumTotal(item.details, detailsIds.HSM)) +
          ';' +
          (item.contract_enterprise_active
            ? item.contract_enterprise_active
            : '') +
          ';' +
          this.sumAmount(item.details, detailsIds.HSM) +
          ';' +
          this.formatCurrency(
            this.sumTotal(item.details, detailsIds.HSM_ACTIVE_UNIQUE)
          ) +
          ';' +
          (item.contract_enterprise_active_unique
            ? item.contract_enterprise_active_unique
            : '') +
          ';' +
          this.sumAmount(item.details, detailsIds.HSM_ACTIVE_UNIQUE) +
          ';' +
          this.formatCurrency(
            this.sumTotal(item.details, detailsIds.HSM_ACTIVE_CAMPAIGN)
          ) +
          ';' +
          (item.contract_enterprise_active_campaign
            ? item.contract_enterprise_active_campaign
            : '') +
          ';' +
          this.sumAmount(item.details, detailsIds.HSM_ACTIVE_CAMPAIGN) +
          ';' +
          this.formatCurrency(
            this.sumTotal(item.details, detailsIds.ATTENDANCE_PROTOCOL)
          ) +
          ';' +
          (item.contract_attendance_protocol
            ? item.contract_attendance_protocol
            : '') +
          ';' +
          this.sumAmount(item.details, detailsIds.ATTENDANCE_PROTOCOL) +
          ';' +
          this.formatCurrency(
            this.sumTotal(item.details, detailsIds.ACTIVE_CAMPAIGN_SMS)
          ) +
          ';' +
          (item.contract_active_campaign_sms
            ? item.contract_active_campaign_sms
            : '') +
          ';' +
          this.sumAmount(item.details, detailsIds.ACTIVE_CAMPAIGN_SMS) +
          ';' +
          this.formatCurrency(this.sumTotal(item.details, detailsIds.MESSAGE)) +
          ';' +
          (item.contract_message ? item.contract_message : '') +
          ';' +
          this.sumAmount(item.details, detailsIds.MESSAGE) +
          ';' +
          this.formatCurrency(
            this.sumTotal(item.details, detailsIds.SESSION_AUTHENTICATION)
          ) +
          ';' +
          (item.contract_enterprise_session_authentication
            ? item.contract_enterprise_session_authentication
            : '') +
          ';' +
          this.sumAmount(item.details, detailsIds.SESSION_AUTHENTICATION) +
          ';' +
          this.formatCurrency(
            this.sumTotal(item.details, detailsIds.SESSION_UTILITY)
          ) +
          ';' +
          (item.contract_enterprise_session_utility
            ? item.contract_enterprise_session_utility
            : '') +
          ';' +
          this.sumAmount(item.details, detailsIds.SESSION_UTILITY) +
          ';' +
          this.formatCurrency(
            this.sumTotal(item.details, detailsIds.SESSION_MARKETING)
          ) +
          ';' +
          (item.contract_enterprise_session_marketing
            ? item.contract_enterprise_session_marketing
            : '') +
          ';' +
          this.sumAmount(item.details, detailsIds.SESSION_MARKETING) +
          ';' +
          this.formatCurrency(
            this.sumTotal(item.details, detailsIds.SESSION_SERVICE)
          ) +
          ';' +
          (item.contract_enterprise_session_service
            ? item.contract_enterprise_session_service
            : '') +
          ';' +
          this.sumAmount(item.details, detailsIds.SESSION_SERVICE) +
          ';' +
          this.formatCurrency(
            this.sumTotal(item.details, detailsIds.ENTERPRISE_NUMBER)
          ) +
          ';' +
          (item.contract_enterprise_number
            ? item.contract_enterprise_number
            : '') +
          ';' +
          this.sumAmount(item.details, detailsIds.ENTERPRISE_NUMBER) +
          ';' +
          this.formatCurrency(
            this.sumTotal(item.details, detailsIds.ADDITIONAL)
          ) +
          ';' +
          (item.contract_additional ? item.contract_additional : '') +
          ';' +
          this.sumAmount(item.details, detailsIds.ADDITIONAL) +
          ';' +
          this.formatCurrency(
            this.sumTotal(item.details, detailsIds.PROJECT_ACQUISITION)
          ) +
          ';' +
          (item.contract_project_aquisition
            ? item.contract_project_aquisition
            : '') +
          ';' +
          this.sumAmount(item.details, detailsIds.PROJECT_ACQUISITION) +
          ';' +
          this.formatCurrency(
            this.sumTotal(item.details, detailsIds.SETUP_BASE)
          ) +
          ';' +
          (item.contract_setup_base ? item.contract_setup_base : '') +
          ';' +
          this.sumAmount(item.details, detailsIds.SETUP_BASE) +
          ';' +
          this.formatCurrency(
            this.sumTotal(item.details, detailsIds.PROJECT_BASE)
          ) +
          ';' +
          (item.contract_project_base ? item.contract_project_base : '') +
          ';' +
          this.sumAmount(item.details, detailsIds.PROJECT_BASE) +
          ';' +
          this.formatCurrency(
            this.sumTotal(item.details, detailsIds.CANCELLATION)
          ) +
          ';' +
          (item.contract_consulting ? item.contract_consulting : '') +
          ';' +
          this.sumAmount(item.details, detailsIds.CANCELLATION) +
          ';' +
          this.formatCurrency(
            this.sumTotal(item.details, detailsIds.CONTRACTUAL_FINES)
          ) +
          ';' +
          (item.contract_fines ? item.contract_fines : '') +
          ';' +
          this.sumAmount(item.details, detailsIds.CONTRACTUAL_FINES) +
          ';';

        linesArray.push(line);
      });
      return linesArray;
    },
    formatCurrency(value) {
      if (!value) {
        value = 0;
      }
      return value.toLocaleString();
    },
    getStatus(status) {
      switch (status) {
        case 0:
          return 'Não Conferida';
        case 1:
          return 'Conferida';
        case 2:
          return 'Venda Gerada';
        case 3:
          return 'Cancelada';
        case 4:
          return 'Paga';
        case 5:
          return 'Parcialmente Paga';
        case 6:
          return 'Expirado';
        default:
          break;
      }
    },
    calcAditionals(price_total, discount, plan) {
      let total = 0;
      total = price_total - discount;
      return total > plan ? total - plan : 0;
    },
  },
  watch: {
    amount() {
      if (this.page == 1) {
        this.callData();
      } else {
        this.page = 1;
      }
    },
    page() {
      this.callData();
    },
    sortType() {
      this.callData();
    },
    sortReverse() {
      this.callData();
    },
  },
  mounted() {
    window.scroll(0, 0);
    this.clearAlert();
  },
};
</script>

<style scoped>
.inputNumberFilter {
  width: 100px;
}

.inputTextFilter {
  width: 200px;
}
</style>
